<div class="container container_type_main">
  <div class="subtitle h2 mt-32">{{ 'subscriptions-page.title' | translate }}</div>
  <div class="subs-list">
    <div class="subs">
      <div class="subs__content">
        <div class="subs__title">{{ 'subscriptions-page.privet-plus-subscription-title' | translate }}
          <span *ngIf="promo && (privetPlusSubscriptionStatus == SubscriptionStatus.ACTIVE)">{{ 'subscriptions-page.gift' | translate }}</span>
        </div>
        <div class="subs__text">{{ 'subscriptions-page.privet-plus-subscription-description' | translate }}</div>
      </div>
      <div class="subs__button">
          <div #privetPlusButton class="button button_type_recommendation" *ngIf="privetPlusSubscriptionStatus != SubscriptionStatus.ACTIVE" (click)="activatePrivetPlus()"
               [class.button_type_load]="loadInProgress">
            <div class="button__text">{{ 'subscriptions-page.subscribe-button' | translate }}</div>
            <div class="button__subtext">{{ 'subscriptions-page.privet-plus-subscription-price' | translate }}</div>
          </div>
          <div #privetPlusButton class="button button_type_dark" *ngIf="privetPlusSubscriptionStatus == SubscriptionStatus.ACTIVE"
               (click)="deactivatePrivetPlus()">
            <div class="button__text">{{ 'subscriptions-page.subscribed-button-new' | translate }}</div>
          </div>
      </div>
    </div>

      <div class="subs">
        <div class="subs__content">
          <div class="subs__title">{{ 'subscriptions-page.privet-subscription-title' | translate }}
            <span *ngIf="promo && (privetSubscriptionStatus == SubscriptionStatus.ACTIVE)">{{ 'subscriptions-page.gift' | translate }}</span>
          </div>
          <div class="subs__text">{{ 'subscriptions-page.privet-subscription-description' | translate }}</div>
        </div>
        <div class="subs__button">
            <div #privetButton class="button button_type_recommendation" *ngIf="privetSubscriptionStatus != SubscriptionStatus.ACTIVE" (click)="activatePrivet()"
                 [class.button_type_load]="loadInProgress">
              <div class="button__text">{{ 'subscriptions-page.subscribe-button' | translate }}</div>
              <div class="button__subtext">{{ 'subscriptions-page.privet-subscription-price' | translate }}</div>
            </div>
            <div #privetButton class="button button_type_dark" *ngIf="privetSubscriptionStatus == SubscriptionStatus.ACTIVE"
                 (click)="deactivatePrivet()">
              <div class="button__text">{{ 'subscriptions-page.subscribed-button-new' | translate }}</div>
            </div>
        </div>
      </div>
  </div>
  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>
